var map = {
	"./Lockton_Marine_P&I_Market_Review_2023.pdf": 500,
	"./Lockton_Marine_P&I_Market_Review_2024.pdf": 501,
	"./Lockton_Marine_P&I_Market_Review_2025.pdf": 502,
	"./Lockton_Marine_P&I_Market_Review_2025_Edition.pdf": 195,
	"./Lockton_Marine_P&I_american-club.pdf": 503,
	"./Lockton_Marine_P&I_britania.pdf": 504,
	"./Lockton_Marine_P&I_gard.pdf": 505,
	"./Lockton_Marine_P&I_japan.pdf": 506,
	"./Lockton_Marine_P&I_london.pdf": 507,
	"./Lockton_Marine_P&I_north-standard.pdf": 508,
	"./Lockton_Marine_P&I_shipowners.pdf": 509,
	"./Lockton_Marine_P&I_skuld.pdf": 510,
	"./Lockton_Marine_P&I_steamship-mutual.pdf": 511,
	"./Lockton_Marine_P&I_swedish-club.pdf": 512,
	"./Lockton_Marine_P&I_uk-pi-club.pdf": 513,
	"./Lockton_Marine_P&I_west.pdf": 514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 499;